import styled from 'styled-components'
import {Form, Input, Button} from 'global/styles/styles.js';

const S = {};


S.ParagonexTransfer = styled(Form)` 
    display: flex;
    width: 20%;
    justify-content: center;
`;

S.Row = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`;

S.InputWrapper = styled.div`
    position: relative;
    margin-bottom: 2.25rem;
    width: 100%;
`;

S.Input = styled(Input)`
    box-shadow: none;
    display: block;
    height: 3rem;
    width: 100%;
    &.has-error{
        border: .08rem solid red;
    }
    &.is-valid{
        border: .08rem solid #63dd7d;
    }
`;

S.ConfrimValue = styled.div`
    color: #fff;
    font-size: 1.2rem;
    margin: 1rem 0; 
    font-weight: 500;
    text-align: center;
`;

S.Error = styled.div`
    color: red;
    margin-top: 0;
    font-size: 0.83rem;
    padding: 0.3rem 1.2rem;
`;

S.Limits = styled.div`
    display: flex;
    flex-direction: column;
    margin: 1rem 0;
`;

S.LimitsRow = styled.div`
    display: flex;
    color: #6D6D6D;
    margin: 0.5rem 0;
`;

S.Label = styled.label`
    margin-top: 1rem;
    margin-right: 2.08rem;
    padding: 0 0 0 1rem;
    position: relative;
    display: flex;
    overflow: hidden;
    color: #6D6D6D;
    text-transform: uppercase;
    font-size: 1.1rem;
    font-weight: bold;
`;

S.TransferMethodChooser = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 1.5rem 0;
`;

S.TransferMethodField = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

S.TransferMethod = styled.div`
    color: #6D6D6D;
    text-transform: uppercase;
    font-size: 1.3rem;
    font-weight: bold;
    cursor: pointer;
    position: relative;
    color: #4B4B4D;
    font-weight: ${({ isActive }) => (isActive == true ? 700 : 400)};
    color: ${({ isActive }) => (isActive == true ? '#f8941e' : '#4b4b4d')};

    &:after{
        content: '';
        height: 3px;
        background-color: #09a83b;
        display: ${({ isActive }) => (isActive == true ? 'block' : 'none')};
        left:0;
        right:0;
        width: auto;
        position: absolute;
    }
`;

S.Body = styled.div`
    width: 80%;

    .notification-container-top-center {
        position: unset;
        transform: unset;
        display: flex;
        justify-content: center;
    }
`;

S.Cover = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,0.5);
    justify-content: center;
    align-items: center;
    display: flex;
    z-index: 5;
`;

S.SubmitBtn = styled(Button)`
    border: none;
    background-color: #09A83B;
    
    cursor: pointer;
    display: block;
    cursor: pointer;
    box-shadow: 0px 1px 1px #00000029;
    height: 3rem;
    color: #fff;
    font-size: 1.2rem;
    font-weight: 600;
    text-align: center;
    border-radius: 5px;
    transition-duration: 1s;

    &:disabled {
        background-color: #424242;
        opacity: 0.5;
        transition-duration: 1s;
    } 
`; 

S.CancelBtn  = styled(Button)`
    border: none;
    background-color: #424242;
    cursor: pointer;
    display: block;
    cursor: pointer;
    box-shadow: 0px 1px 1px #00000029;
    height: 3rem;
    color: #fff;
    font-size: 1.2rem;
    font-weight: 600;
    text-align: center;
    border-radius: 5px;
`;

export default S;
